import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M83.743 26.256c-.363 0-.714.048-1.055.124a7 7 0 0 0-1.137-.101l-35.542-.023a7.38 7.38 0 0 0-7.384 7.379V65.92c0 .804.89 1.288 1.565.852l6.211-4.011a1.01 1.01 0 0 1 1.092-.005l7.381 4.669c.343.217.782.209 1.116-.021l7.208-4.951a1.01 1.01 0 0 1 1.141-.005l7.342 4.949c.345.233.798.23 1.142-.005l7.165-4.926a1.01 1.01 0 0 1 1.166.012l5.79 4.153a1.015 1.015 0 0 0 1.606-.824V31.063a4.81 4.81 0 0 0-4.808-4.808z"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M36.394 26.256a7.38 7.38 0 0 0-7.384 7.379v52.3c0 .804.89 1.289 1.565.853l6.211-4.011a1.01 1.01 0 0 1 1.093-.005l7.381 4.67c.343.217.782.209 1.117-.021l7.208-4.951a1.015 1.015 0 0 1 1.142-.005l7.341 4.949c.346.233.798.23 1.142-.005l7.165-4.926a1.015 1.015 0 0 1 1.166.01l5.79 4.154a1.014 1.014 0 0 0 1.606-.824v-54.76a4.81 4.81 0 0 1 4.808-4.808z"
      clipRule="evenodd"
    />
    <path
      stroke="#001A43"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={4.5}
      d="M42.444 53.51h22.363M42.444 41.85h22.363M42.444 64.629h13.054"
    />
    <path
      stroke="#00D8D8"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M96.5 74.629a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    />
    <path
      fill="#D8FFFF"
      d="M12.915 32.386a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M16.415 48.85a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m33.573 94.41-9.994 9.992M33.573 104.402l-9.994-9.993M103.566 36.862v14.133M110.633 43.93H96.5"
    />
  </svg>
);
const SvgEnrichedIconBillsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconBillsBrand);
export default Memo;
